"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _nuiIntlRuntime = _interopRequireWildcard(require("@concur/nui-intl-runtime"));
var _reactHelmet = require("react-helmet");
var _client = _interopRequireDefault(require("@concur/nui-config/lib/client"));
var _reactUiTheming = require("@concur/react-ui-theming");
var _LayoutGrid = _interopRequireDefault(require("@concur/nui-layouts/LayoutGrid"));
var _reactRouter = require("react-router");
var _Analytics = _interopRequireDefault(require("./Analytics"));
var _config = _interopRequireDefault(require("../config"));
var _analytics = require("../util/analytics");
var _constants = require("../constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var NuiPage = function NuiPage(props) {
  var contentHeader = props.contentHeader,
    baseUrl = props.baseUrl,
    nuiPage = props.nuiPage,
    _props$nuiPage = props.nuiPage,
    _props$nuiPage2 = _props$nuiPage === void 0 ? {} : _props$nuiPage,
    _props$nuiPage2$brand = _props$nuiPage2.brandingId,
    brandingId = _props$nuiPage2$brand === void 0 ? _config.default.nui.default_brandingId : _props$nuiPage2$brand,
    theme = _props$nuiPage2.theme,
    is16ColsEnabled = _props$nuiPage2.is16ColsEnabled,
    isFullyResponsive = _props$nuiPage2.isFullyResponsive,
    isFluid = _props$nuiPage2.isFluid,
    serverContentDensity = _props$nuiPage2.contentDensity,
    getAppDimensionsForAnalytics = props.getAppDimensionsForAnalytics,
    getCoreDataForAnalytics = props.getCoreDataForAnalytics,
    _props$userPrefs = props.userPrefs,
    _props$userPrefs2 = _props$userPrefs === void 0 ? {} : _props$userPrefs,
    isLoggedIn = _props$userPrefs2.isLoggedIn,
    fetchNuiPageData = props.fetchNuiPageData,
    _props$disableDefault = props.disableDefaultLayout,
    disableDefaultLayout = _props$disableDefault === void 0 ? false : _props$disableDefault;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    ui5EnabledAppContent = _useState2[0],
    setUi5EnabledAppContent = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isClient = _useState4[0],
    setIsClient = _useState4[1];

  // Fetch nuiPage data if it does not exist
  (0, _react.useEffect)(function () {
    if (isLoggedIn && !nuiPage) {
      fetchNuiPageData();
    }
  }, []);
  var localeData = (0, _nuiIntlRuntime.getLocaleData)(props);
  var signinData = {};
  try {
    signinData = window.NUI_TRANSLATIONS;
  } catch (error) {
    try {
      signinData = window.NUI_TRANSLATIONS;
      console.warn("Translation file for language ".concat(localeData.lang, " not found in @concur/nui-auth/translations/. Using ").concat(_constants.DEFAULT_LANGUAGE, " translations. Try updating the @concur/nui-auth package."));
    } catch (error) {
      console.warn("Translation file for language ".concat(localeData.lang, " and default ").concat(_constants.DEFAULT_LANGUAGE, " translations not found in @concur/nui-auth/translations/. Try updating the @concur/nui-auth package."));
    }
  }

  // Pass messages through from parent NuiIntlProvider, if we are nested
  var outerMessages = {};

  // Check if nested in another NuiIntlProvider
  if ((0, _react.useContext)(_nuiIntlRuntime.IntlContext)) {
    var _useIntl;
    outerMessages = ((_useIntl = (0, _nuiIntlRuntime.useIntl)()) === null || _useIntl === void 0 || (_useIntl = _useIntl.preferences) === null || _useIntl === void 0 ? void 0 : _useIntl.messages) || {};
  }
  var intlData = _objectSpread(_objectSpread({}, outerMessages), signinData);

  // Parse client side or server side config
  var clientConfig = (0, _client.default)();

  // Use client side config if it exists
  var config = Object.keys(clientConfig).length > 0 ? clientConfig : _config.default;
  var clientContentDensity = config.nui.content_density;
  var useCompactStyles = clientContentDensity === 'compact' || serverContentDensity === 'compact';
  var bodyClassNames = (0, _classnames.default)("cnqr-theme-".concat(brandingId), {
    'cnqr-body-overflow-visible': !is16ColsEnabled && !isFullyResponsive,
    'ui5-content-density-compact': process.env.NUI_SHELL_USE_UI5WCR && useCompactStyles,
    'nui-widgets-density-compact': useCompactStyles
  });
  var content = disableDefaultLayout ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactRouter.Outlet, null), props.children) : /*#__PURE__*/_react.default.createElement(_LayoutGrid.default, {
    id: "cnqr-app-content",
    className: "cnqr-app-content",
    fluid: isFluid,
    fullyResponsive: isFullyResponsive,
    role: "main",
    use16Cols: is16ColsEnabled
  }, /*#__PURE__*/_react.default.createElement(_reactRouter.Outlet, null), props.children);
  var AppContent = /*#__PURE__*/_react.default.createElement(_reactUiTheming.ThemeProvider, {
    theme: theme,
    density: serverContentDensity || clientContentDensity
  }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.default, {
    messages: intlData,
    localeData: localeData
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "react-component-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_reactHelmet.Helmet, null, /*#__PURE__*/_react.default.createElement("body", {
    id: "cnqrBody",
    className: bodyClassNames
  })), /*#__PURE__*/_react.default.createElement("span", {
    id: "nullSpan",
    tabIndex: -1
  }), contentHeader, content, /*#__PURE__*/_react.default.createElement(_Analytics.default, {
    baseUrl: baseUrl,
    getAppDimensionsForAnalytics: getAppDimensionsForAnalytics,
    getCoreDataForAnalytics: getCoreDataForAnalytics,
    analyticsParams: (0, _analytics.getAnalyticsParamsForDataCenter)(config)
  }))));
  (0, _react.useEffect)(function () {
    if (process.env.NUI_SHELL_USE_UI5WCR) {
      // Dynamically import UI5WCR Assets (theme support)
      Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@ui5/webcomponents-react/dist/Assets'));
      });
      // Dynamically import UI5WCR ThemeProvider
      Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@ui5/webcomponents-react'));
      }).then(function (_ref) {
        var ThemeProvider = _ref.ThemeProvider;
        setUi5EnabledAppContent(/*#__PURE__*/_react.default.createElement(ThemeProvider, null, AppContent));
      }).catch(function (error) {
        console.error('Error loading ThemeProvider:', error);
      });
    }
  }, [theme]);

  // prevent hydration error with using useEffect to add the ui5 themeprovider
  (0, _react.useEffect)(function () {
    setIsClient(true);
    return function () {
      setIsClient(false);
    };
  }, []);
  return process.env.NUI_SHELL_USE_UI5WCR && isClient ? ui5EnabledAppContent : AppContent;
};
NuiPage.propTypes = {
  baseUrl: _propTypes.default.string,
  children: _propTypes.default.any,
  contentHeader: _propTypes.default.any,
  fetchNuiPageData: _propTypes.default.func,
  isLoggedIn: _propTypes.default.bool,
  nuiPage: _propTypes.default.any,
  getAppDimensionsForAnalytics: _propTypes.default.func,
  disableDefaultLayout: _propTypes.default.bool
};
var _default = exports.default = NuiPage;